/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.select_all.init());

App.select_all = {
  init() {
    if ($("input.js-select-all").length > 0) {
      return $(document)
        .off("click", "input.js-select-all", App.select_all.clicked)
        .on("click", "input.js-select-all", App.select_all.clicked);
    }
  },


  // When a checkbox is clicked,
  // - get current state (checked|not)
  // - if it has a data-select-scope, set those to current state
  // Then make sure "master" toggles are in correct state
  clicked(evt) {
    const cb = evt.target;
    const {
      checked
    } = cb;

    if (cb.hasAttribute("data-select-scope")) {
      $($(cb).attr("data-select-scope")).prop("checked", checked);
    }

    return App.select_all.set_master_toggles();
  },

  // - get all input[data-select-scope]
  // - if all its scope are checked, it should be checked, otherwise not
  set_master_toggles() {
    $("input[data-select-scope]").each(function() {
      const $cb = $(this);
      const scope = $cb.attr("data-select-scope");

      // Only do this if the master has children
      if ($(`${scope}:not(:checked)`).length > 0) {
        return $cb.prop("checked", ($(`${scope}:not(:checked)`).length === 0));
      }
    });

    return App.emit("select-all-changed", null);
  }
};
